/**
 * gridFilterUtils — pure helpers for EditableGrid's Excel-style per-column
 * value filters (BUG-2026-0143). Extracted from EditableGrid (600-line cap).
 */
import type { GridColumn } from './EditableGrid';

/** Column filter state: field → set of INCLUDED normalized values. */
export type ColumnFilters = Record<string, Set<string>>;

/** Null/undefined/'' collapse to '' so blanks are one filterable bucket. */
export const normalizeFilterValue = (v: unknown): string =>
  v === null || v === undefined || v === '' ? '' : String(v);

export const rowPassesColumnFilters = (
  row: Record<string, unknown>,
  filters: ColumnFilters,
  exceptField?: string,
): boolean => {
  for (const [field, allowed] of Object.entries(filters)) {
    if (field === exceptField) continue;
    if (!allowed.has(normalizeFilterValue(row[field]))) return false;
  }
  return true;
};

export const filterDisplayLabel = (col: GridColumn, value: string): string => {
  if (value === '') return '(Blanks)';
  const item = col.optionItems?.find((o) => o.value === value);
  return item ? item.label : value;
};
